export default __webpack_public_path__ + "static/media/Cls1.a6cc6f68.png";